import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import * as actions from '../action';
import * as c from '../constant';

function AssessmentLevelContent({
  handleAddModal,
  handleEdit,
  handleRemove,
  assessmentLevelId,
  getSingleAssessmentLevel,
  assessmentLevelInfo,
  permissions,
}) {
  useEffect(() => {
    if (_.isEmpty(assessmentLevelId)) return;
    getSingleAssessmentLevel(assessmentLevelId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(assessmentLevelId)) return;
    getSingleAssessmentLevel(assessmentLevelId);
  }, [assessmentLevelId]);

  return (
    <div className="d-flex flex-column h-100">
      {Acl(permissions, ['CREATE E2E RPT MACHINERY ASSESSMENT LEVELS']) && (
        <div className="row mb-3">
          <button
            type="button"
            onClick={handleAddModal}
            className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold px-4 ml-auto"
            style={{ marginRight: 30 }}
          >
            <i className="fas fa-plus" />
            <span className="ml-2">Add Assessment Level</span>
          </button>
        </div>
      )}
      <div className="ml-3 p-3 card right-section h-100">
        {!_.isEmpty(assessmentLevelInfo) ? (
          <React.Fragment>
            <div className="row d-flex justify-content-between align-items-center">
              <div className="col-10">
                <h3 className="mb-0">Information</h3>
              </div>
              <div className="col-2 d-flex align-items-end justify-content-end">
                {Acl(permissions, [
                  'UPDATE E2E RPT MACHINERY ASSESSMENT LEVELS',
                ]) && (
                  <button
                    type="button"
                    className="btn-blank"
                    onClick={handleEdit(assessmentLevelInfo)}
                  >
                    <i className="far fa-edit icon-edit" />
                  </button>
                )}
                {Acl(permissions, [
                  'DELETE E2E RPT MACHINERY ASSESSMENT LEVELS',
                ]) && (
                  <button
                    type="button"
                    className="btn-blank"
                    onClick={handleRemove(assessmentLevelInfo)}
                  >
                    <i className="far fa-trash-alt icon-delete" />
                  </button>
                )}
              </div>
            </div>
            <div className="mt-3 pt-4 border-top">
              <table className="transaction-table table table-borderless table-striped table-sm ">
                <tbody>
                  <tr>
                    <td className="span-title2 font-weight-bold" width="250">
                      Actual Use
                    </td>
                    <td className="text-dark" width="1" />
                    <td className="text-dark">
                      {_.get(
                        assessmentLevelInfo,
                        'attributes.classification'
                      ) || '--'}
                    </td>
                  </tr>
                  <tr>
                    <td className="span-title2 font-weight-bold" width="250">
                      Assessment Level
                    </td>
                    <td className="text-dark" width="1" />
                    <td className="text-dark">
                      {_.get(
                        assessmentLevelInfo,
                        'attributes.assessment_level'
                      ) || '--'}
                    </td>
                  </tr>
                  <tr>
                    <td className="span-title2 font-weight-bold" width="250">
                      Ordinance Revision
                    </td>
                    <td className="text-dark" width="1" />
                    <td className="text-dark">
                      {_.get(
                        assessmentLevelInfo,
                        'attributes.ordinance_revision_name'
                      ) || '--'}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </React.Fragment>
        ) : (
          <div className="d-flex align-items-center justitfy-content-center h-100">
            <div className="text-center mx-auto py-4">
              <img
                src={emptyStateImage}
                className="img-responsive image-wrapper mb-4 mt-3"
                alt="Empty State"
              />
              <p className="emp-title mb-0"> No Item Found </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

AssessmentLevelContent.propTypes = {
  handleAddModal: PropTypes.instanceOf(Function).isRequired,
  handleEdit: PropTypes.instanceOf(Function).isRequired,
  handleRemove: PropTypes.instanceOf(Function).isRequired,
  getSingleAssessmentLevel: PropTypes.instanceOf(Function).isRequired,
  assessmentLevelInfo: PropTypes.instanceOf(Object).isRequired,
  assessmentLevelId: PropTypes.string.isRequired,
  permissions: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  assessmentLevelInfo:
    _.get(api, `${c.GET_SINGLE_ASSESSMENT_LEVEL}.item`) || {},
  assessmentLevelId: _.get(match, 'params.assessmentLevelId') || '',
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(AssessmentLevelContent);
